/** Shared media-URL resolver. Why this exists:
 *
 * Emergent's React build bakes `REACT_APP_BACKEND_URL` to a fixed host
 * (e.g. `https://narration-hub-16.emergent.host`). When the app is served
 * from a custom domain like `www.storylo.co.uk`, that means every image,
 * `<video>` and subtitle track loads cross-origin. Browsers tolerate that
 * for plain images, but `<video crossOrigin="anonymous">` (which we need
 * for subtitle tracks) becomes very strict — and inconsistent CORS / CDN
 * cache headers cause the whole player to silently fail.
 *
 * Since the ingress on the custom domain already routes `/api/*` straight
 * to the backend, the cleanest fix is: resolve relative paths against the
 * current page origin, falling back to the build-time backend URL only
 * when no `window` is available (SSR, build helpers).
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function mediaUrl(path) {
  if (!path || typeof path !== "string") return path;
  if (path.startsWith("http")) return path;
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return `${BACKEND_URL}${path}`;
}

export default mediaUrl;
